import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import {getWorkListPagesLinks} from "../../actions/workDocumentsActions";
import PhotoGallery from '../Common/fotorama/PhotoGallery';
import PopupWrapper from "../Common/PopupWrapper";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from 'jquery'
import CreateClaimExternal from "../Claim/CreateClaimExternal";
import {WorkplaceTypes} from "../Common/constants";

class WorkDocuments extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showViewer: false,
            images: null
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.PersContract_ListForPO.execute(key, {withParams: true}));
            await this.props.dispatch(this.props.PersonalStage_WorkListForPO.execute(key, {withStyle: true}));
            await this.props.dispatch(this.props.PersonalStage_WorkStageForPO.execute(key));
            await this.props.dispatch(this.props.PersJobDescExam_ListForPersForPO.execute(key));
            await this.props.dispatch(this.props.PersJobDescExam_ListForPersForArcPO.execute(key));
        } catch (e) {
            console.error(e);
        }
    }

    renderContract = (h) => {
        return (
            <div className="row m-3" key="BaseContractNumber">
                <div className="col-md-12">
                    <h2> {i18next.t("YourContractNumber")}: <strong>{h.ed("BaseContractNumber")} {i18next.t("YourContractNumber_From")} {h.ed("BaseContractDate")}</strong>
                    </h2></div>
            </div>
        )
    }

    renderCellLink = (cellParams) => {
//        const rowIndex = this.props.PersJobDescExam_ListForPersForPO.getRowIndex2(row);
        if (cellParams.fieldInfo.Name === "ListUrl") {
            /*
                        let prefix = 'http://';
                        let url = row.ListUrl;
                        if (url.substr(0, prefix.length) !== prefix) {
                            url = prefix + url;
                        }
            */
            return (
                <div>
                    <label>
                        <a href={cellParams.row.ListUrl} rel="noopener noreferrer">{cellParams.row.ListUrl}</a>
                    </label>
                </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    styleProviderWorkListForPO = (rowIndex, row) => {
        return (row.ThisCompany === 1 ? {
            backgroundColor: 'PaleTurquoise',
            fontWeight: 'bold'
        } : {backgroundColor: 'Beige'})
    }

    showWorkList = (e) => {
        e.preventDefault();
        this.props.dispatch(getWorkListPagesLinks())
            .then(() => {
                let urlList = [];
                if (this.props.image) {
                    urlList = this.props.image.map(row => {
                        return ({
                            img: window.config.apiRoot + row.img,
                            thumb: window.config.apiRoot + row.thumb
                        })
                    });
                }
                this.setState({showViewer: urlList.length > 0, images: urlList/*, imagesLoaded: true*/});
            });
        //this.setState({showViewer: true, images: [], imagesLoaded: false});
    };

    onCloseWorkListPopup = () => {
        this.setState({showViewer: false, images: null/*, imagesLoaded: false*/});
    };

    downloadWorkList = () => {

        const tokenPromise = AuthProvider.getToken();

        tokenPromise.then(token => {

            const downloadPath = pathJoin(window.config.apiRoot, "WorkDocuments", "DownloadWorkList") + "?" + $.param({
                b_token: token, tabNum: null
            });

            window.open(downloadPath, '_blank');
        });
    };

    renderWorkListPopup = () => {
        if (!this.state.showViewer)
            return null;

        let self = this;
        let imagesLoaded = this.state.images !== null;
        let imagesExists = imagesLoaded && this.state.images.length > 0;

        return (
            <PopupWrapper onClose={this.onCloseWorkListPopup}
                          popupVisible={this.state.showViewer}
                          title={i18next.t('EmploymentHistoryCopy')}
                          renderButtons={() => {
                              return <div className="modal-footer text-right">
                                  {imagesExists && this.props.appParams.showButtonsWorkList &&
                                      <button type="button"
                                              className="btn btn-regular -default"
                                              data-dismiss="modal"
                                              onClick={self.downloadWorkList}>
                                          {i18next.t('DownloadWorkList')}
                                      </button>}
                                  {this.props.appParams.showButtonsWorkList &&
                                      <button type="button"
                                              className="btn btn-regular -default"
                                              data-dismiss="modal"
                                              onClick={self.onCloseWorkListPopup}>
                                          {i18next.t('Close')}
                                      </button>
                                  }
                              </div>
                          }}>
                <div style={{minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {imagesExists &&
                        <PhotoGallery imageList={this.state.images}/>
                    }
                    {imagesLoaded && !imagesExists &&
                        <span>{i18next.t('NoImages')}</span>
                    }
                    {!imagesLoaded &&
                        <span>{i18next.t('ImagesProcessing')}</span>
                    }
                </div>
            </PopupWrapper>
        )
    }

    render() {
        return (
            <>
                {this.props.appParams.showContract &&
                    <PlaceholderWrapper placeholderId="10" showSplitterLine={false} canCollapse={false}
                                        staticTitle={i18next.t("EmployeeContractNumber")}>
                        <ComplexParam dataItem={this.props.PersContract_ListForPO} readOnly={true}
                                      showApplyButton={false} showSearchBar={false}
                                      renderParams={this.renderContract}/>
                    </PlaceholderWrapper>
                }
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i
                                        className='fa fa-bank'/> {i18next.t("TotalWorkExperience")}<CreateClaimExternal
                                        style={{marginLeft: '10px'}} claimMenuId="CMD_LK_CREATE_SENIORITY_RECORD"/></>}
                                    showSplitterLine={false} canCollapse={true}>
                    <GridView dataItem={this.props.PersonalStage_WorkStageForPO}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="30"
                                    title={<><i className='fa fa-bank'/> {i18next.t("EmploymentHistory")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    {this.props.appParams.showButtonsWorkList &&
                        <>
                            <button type="button" className="btn btn-regular -default"
                                    onClick={this.showWorkList}>{i18next.t('EmploymentHistoryCopy')}
                            </button>
                            <button type="button" className="btn btn-regular -default"
                                    onClick={this.downloadWorkList}>{i18next.t('DownloadWorkList')}
                            </button>
                        </>
                    }
                    <CreateClaimExternal style={{marginLeft: '10px'}} claimMenuId="CMD_LK_CREATE_GET_WORK_BOOK"/>
                    <CreateClaimExternal style={{marginLeft: '10px'}} claimMenuId="CMD_LK_CREATE_GET_WB_INSERT"/>
                    <div style={{marginTop: '10px'}}/>
                    {this.renderWorkListPopup()}
                    <GridView dataItem={this.props.PersonalStage_WorkListForPO}
                              rowStyleProvider={this.styleProviderWorkListForPO}
                    />
                </PlaceholderWrapper>
                {this.props.appParams.showPersJobDescExam &&
                    <>
                        <PlaceholderWrapper placeholderId="40" title={<><i
                            className='fa fa-bank'/> {i18next.t("JobInstructionsAndDepartmentRegulations")}</>}
                                            showSplitterLine={false} canCollapse={true}>
                            <GridView dataItem={this.props.PersJobDescExam_ListForPersForPO}
                                      renderCellEx={this.renderCellLink}/>
                        </PlaceholderWrapper>
                        <PlaceholderWrapper placeholderId="50"
                                            title={<><i
                                                className='fa fa-bank'/> {i18next.t("JobInstructionsAndDepartmentRegulations") + " " + i18next.t('InArchive')}</>}
                                            showSplitterLine={false} canCollapse={true} collapsed={true}>
                            <GridView dataItem={this.props.PersJobDescExam_ListForPersForArcPO}
                                      renderCellEx={this.renderCellLink}/>
                        </PlaceholderWrapper>
                    </>
                }
            </>
        )
    }
}

WorkDocuments.propTypes = {
    dispatch: PropTypes.func.isRequired,
    PersContract_ListForPO: PropTypes.object,
    PersonalStage_WorkListForPO: PropTypes.object,
    PersonalStage_WorkStageForPO: PropTypes.object,
    PersJobDescExam_ListForPersForPO: PropTypes.object,
    PersJobDescExam_ListForPersForArcPO: PropTypes.object,
    image: PropTypes.any,
    appParams: PropTypes.object
}

WorkDocuments.defaultProps = {};

function mapStateToProps(state, ownProps) {
    function getDataItem(isParamSet = false) {
        switch (state.appState.appParams.workplaceType) {
            case WorkplaceTypes.Baltika: {
                return state.workDocumentsItems.PersonalStage_WorkListForPO;
            }
            case WorkplaceTypes.Slavutich: {
                return state.workDocumentsItems.PersonalStage_WorkListForPONew_Slav;
            }
            default: {
                return state.workDocumentsItems.PersonalStage_WorkListForPO;
            }
        }
    }

    return {
        PersContract_ListForPO: state.workDocumentsItems.PersContract_ListForPO,
        PersonalStage_WorkListForPO: getDataItem(),
        PersonalStage_WorkStageForPO: state.workDocumentsItems.PersonalStage_WorkStageForPO,
        PersJobDescExam_ListForPersForPO: state.workDocumentsItems.PersJobDescExam_ListForPersForPO,
        image: state.workDocumentsState.image,
        appParams: state.appState.appParams,
        PersJobDescExam_ListForPersForArcPO: state.workDocumentsItems.PersJobDescExam_ListForPersForArcPO

    }
}

export default connect(mapStateToProps)(WorkDocuments)